// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner__spinner___n9dhp","bubbly":"spinner__bubbly___HqzZx","b1":"spinner__b1___WMp69","b2":"spinner__b2___axXx4","b3":"spinner__b3___f_KoR"};